<template>
  <div class="homeCon">
    <mt-swipe :auto="4000">
      <mt-swipe-item><img src="../assets/imgs/banner1.png"></mt-swipe-item>
      <mt-swipe-item><img src="../assets/imgs/banner2.png"></mt-swipe-item>
      <mt-swipe-item><img src="../assets/imgs/banner3.png"></mt-swipe-item>
    </mt-swipe>
    <!-- <div class="menusBox">
      <ul>
        <li  @click="toPage(0)">
          <img
              src="../assets/imgs/jxjyHome.png"
              alt=""
            />
            <p>出租车</p>
        </li>
        <li @click="toPage(2)">
          <img
              src="../assets/imgs/road.png"
              alt=""
            />
            <p>道路运输</p>
        </li>
        <li @click="toPage(1)">
          <img
              src="../assets/imgs/zxxxHome.png"
              alt=""
            />
            <p>岗前培训</p>
        </li>
        <li @click="toPage(3)">
          <img
              src="../assets/imgs/wycHome.png"
              alt=""
            />
            <p>安全学习</p>
        </li>
         <li  @click="toPage(4)">
          <img
              src="../assets/imgs/llryHome.png"
              alt=""
            />
            <p>两类人员</p>
        </li>
      </ul>
    </div> -->
    <div class="adBox">
      <img
        src="../assets/imgs/adImg.png"
        alt=""
      />
    </div>
    <div class="weiViewoBox">
      <div class="clearfix">
        <div class="fl">微视频</div>
        <div class="fr">
          <router-link :to="{path:'/weiV'}">更多<img
              src="../assets/imgs/moreIcon.png"
              alt=""
              class="moreIcon"
            /></router-link>
        </div>
      </div>
      <div class="weiVItems">
        <ul class="clearfix">
          <li
            class="fl"
            v-for="item in micVideolist"
            :key="item.index"
          >
            <!-- vType:0--不记时视频 1--要计时视频 -->
            <router-link :to="{path:'/videoD',query:{vObj:JSON.stringify(item),vType:0}}">
              <div class="weiVImgBox">
                <img
                  :src="item.imagePath"
                  alt=""
                  class="weiVImg"
                  :onerror="defaultImg"
                />
                <img
                  src="../assets/imgs/playIcon.png"
                  alt=""
                  class="toPlay"
                />
                <span>{{item.dataduration}}</span>
              </div>
              <p class="videoTit">{{item.title}}</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import tabbar from '../components/tabbar.vue' // 引用组件的地址
import { mapGetters } from 'vuex'
import {
  getPublicCourseware,
  getaccountInfo,
  GetOpenId
} from '../../src/api/Api'
export default {
  name: 'studyProgress',
  components: {
    tabbar: tabbar
  },
  data () {
    return {
      micVideolist: [], // 公开视频
      defaultImg: 'this.src="' + require('../assets/imgs/banner.png') + '"', // 默认图地址
      isHasmicVideolist: true, // 有视频
      temp: {
        code: ''
      },
      baseUrl: window.baseapi.baseApiUrl
    }
  },
  created () {
    console.log('行业' + this.ProfessionId)
    var toW = this.$route.query.pageName
    if (toW === 'uc') {
      this.$router.push({
        path: '/uc'
      })
      return false
    }
    // localStorage.setItem('openid', 'oVC4cwh08C2tJZL1EQWzpZ1ZPUXo') // 本地测试时放开
    this.openid = localStorage.getItem('openid')
    if (
      this.openid === '' ||
      this.openid === null ||
      this.openid === undefined
    ) {
      var code = this.getUrlParam('code')
      if (code === '' || code === null || code === undefined) {
        this.$router.replace({
          path: '/Au',
          query: { pageName: 'home' }
        })
        return false
      }
    } else {
      var UID = sessionStorage.getItem('userId')
      if (UID === '' || UID === null || UID === undefined) {
        this.getUserInfo()
      }
    }
    this.getPublicCoursewaresAA()
  },
  mounted () {
    this.temp.code = this.getUrlParam('code')
    if (
      this.temp.code !== '' &&
      this.temp.code !== null &&
      this.temp.code !== undefined
    ) {
      this.getOpenid()
    }
  },
  methods: {
    getPublicCoursewares () {
      var _this = this
      getPublicCourseware({
        type: 0,
        size: 4
      }).then(res => {
        if (res.data.returnCode === 1) {
          _this.isHasmicVideolist = false
          _this.micVideolist = res.data.returnDate
        } else {
          _this.isHasmicVideolist = true
        }
      })
    },
    getPublicCoursewaresAA () {
      this.$axios({
        method: 'get',
        url: this.baseUrl + '/GetDataService/getPublicCourseware',
        params: { type: 0, size: 4 }
      }).then(res => {
        if (res.data.returnCode === 1) {
          this.isHasmicVideolist = false
          this.micVideolist = res.data.returnDate
        } else {
          this.isHasmicVideolist = true
        }
      })
    },
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      // let url = 'http://www.gx-etrans.com/?code=081kKupB17Tt2c0wgZoB1q6LpB1kKup7&state=home'.split('#')[0]
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
    getOpenid () {
      var tcode = this.temp.code
      if (tcode !== '' && tcode !== null && tcode !== undefined) {
        // GetOpenId({
        //   code: this.temp.code
        // }).then(res => {
        //   if (res.data.code === 200) {
        //     localStorage.setItem('openid', res.data.data.openid)
        //     this.getUserInfo()
        //   }
        // })

        this.$axios({
          method: 'get',
          url: this.baseUrl + '/api/openid',
          params: { code: this.temp.code }
        }).then(res => {
          if (res.data.code === 200) {
            localStorage.setItem('openid', res.data.data.openid)
            this.getUserInfo()
          }
        })
      }
    },
    toPage(t){
      var pageUrl = "";
      if(t===0){
        pageUrl = "/cEdu";
      }
      if(t===2){
        pageUrl = "/rt";
      }
      if(t===1){
        pageUrl = "/spStudy";
      }
      if(t===3){
        pageUrl = "/sfStudy";
      }
      if(t===4){
        pageUrl = "/twoClass";
      }
      sessionStorage.setItem('platform', t) // 继续教育0  专项学习1
      this.$store.dispatch('SetPlatform', t)
       this.$router.push({
          path:pageUrl
       })
    },
    getUserInfo () {
      if (
        localStorage.getItem('openid') === '' ||
        localStorage.getItem('openid') === null ||
        localStorage.getItem('openid') === undefined
      ) {
        this.$router.replace({
          path: '/Au',
          query: { pageName: 'home' }
        })
        return false
      }
      // if (
      //   sessionStorage.getItem('userId') !== '' &&
      //   sessionStorage.getItem('userId') !== null &&
      //   sessionStorage.getItem('userId') !== undefined
      // ) {
      //   return false
      // }
      this.$axios({
        method: 'get',
        url: this.baseUrl + '/safeStudy/login/wxCheckOpenid',
        params: { openid: localStorage.getItem('openid') }
      }).then(res => {
        if (res.data.code === '1000') {
          // 未绑定
          this.$router.push({
            path: '/login'
          })
        } else if (res.data.code === '200') {
          console.log('是安全啊' + res.data.data[0].platform)
          sessionStorage.setItem('token', res.data.data[0].token)
          sessionStorage.setItem('platform', res.data.data[0].platform) // 继续教育0  专项学习1
          this.$store.dispatch('SetToken', res.data.data[0].token)
          this.$store.dispatch('SetStuId', res.data.data[0].uid)
          this.$store.dispatch('SetPlatform', res.data.data[0].platform)
          this.$store.dispatch('SetProfessionId', res.data.data[0].ProfessionId) // 货运1  客运2 危险3 出租5
          sessionStorage.setItem('userName', res.data.data[0].StuName)
          sessionStorage.setItem('sex', res.data.data[0].Sex)
          sessionStorage.setItem('phone', res.data.data[0].Phone)
          sessionStorage.setItem('photo', res.data.data[0].PhotoImage)
          sessionStorage.setItem('userId', res.data.data[0].uid)
          sessionStorage.setItem('companyId', res.data.data[0].Company)
          sessionStorage.setItem('professionId', res.data.data[0].ProfessionId)
          sessionStorage.setItem(
            'professionName',
            res.data.data[0].ProfessionName
          )
          sessionStorage.setItem('IdCard', res.data.data[0].IdCard)
          sessionStorage.setItem('driverNumber', res.data.data[0].driverNumber)
          sessionStorage.setItem('CertificateNo', res.data.data[0].Certificate)
          sessionStorage.setItem('register', res.data.data[0].register)

          sessionStorage.setItem('companyName', res.data.data[0].CompanyName)
          let pageName = this.getUrlParam('state')

          if (pageName === 'uc') {
            this.$router.push({
              path: '/uc'
            })
          } else {
            this.$router.push({
              path: '/'
            })
          }
          this.eId = sessionStorage.getItem('userId')
          this.companyId = sessionStorage.getItem('companyId')
          this.pId = sessionStorage.getItem('professionId')
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    }
  },
  computed: {
    ...mapGetters(['stuId', 'ProfessionId'])
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue